import React from "react";
import Loader from "../../common/Loader";
import FailedJobItem from "./FailedJobItem";

const FailedJobsList = ({ jobs, isLoading, onRetry, onDelete }) => {
  if (isLoading) {
    return <Loader />;
  }

  if (!jobs || jobs.length === 0) {
    return (
      <div className="card shadow-sm">
        <div className="card-body text-center py-5">
          <i
            className="fa fa-check-circle text-success mb-3"
            style={{ fontSize: "2.5rem" }}
          />
          <p className="text-muted mb-0">Aucun job échoué trouvé</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {jobs.map((job) => (
        <FailedJobItem
          key={job.id}
          job={job}
          onRetry={onRetry}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default FailedJobsList;
